<template>
	<v-form @keydown.enter.prevent>
		<v-container v-if="isEdit" key="editable">
			<v-layout row wrap>
				<v-flex xs12>
                    <v-subheader class="text-xs-left pl-0"> This section allows you to set which policies are relevant to this employee. </v-subheader>
					<employee-hr-document-selector v-model="internalValue" :hr-documents="hrPoliciesFiltered" :employee-id="employeeId" no-links class="mb-3" />
				</v-flex>
			</v-layout>
		</v-container>
		<v-container v-else key="readonly">
			<v-layout row wrap>
				<v-flex xs12>
                    <v-subheader class="text-xs-left pl-0"> This section allows you to set which policies are relevant to this employee. </v-subheader>
					<employee-hr-document-selector v-model="internalValue" :hr-documents="hrPoliciesFiltered" :employee-id="employeeId" no-links class="mb-3" :readonly="true" />
				</v-flex>
			</v-layout>
		</v-container>
	</v-form>
</template>

<script>
	import { mapGetters } from 'vuex';
	import formMixin from '@/mixins/employeeFormMixin';
	import EmployeeHrDocumentSelector from '@/components/employee/EmployeeHrDocumentSelector';

	export default {
		components: {
			EmployeeHrDocumentSelector
		},
		mixins: [formMixin],
		props: {
			employeeId: {
				type: String,
				required: false
			}
		},
		data() {
            return {
                internalValue: [...this.value]
            }
        },
        watch: {
			value(newValue) {
				this.internalValue = newValue;
			},
			internalValue(newValue) {
				this.$emit('input', newValue);
			}
		},
        computed: {
			...mapGetters({
				hrPolicies: 'hrDocuments/hrPolicies'
			}),
			hrPoliciesFiltered() {
				return this.hrPolicies.map(x => {
					return {
						id: x.id,
						name: x.name,
						relevantParties: x.relevantParties,
						category: x.category
					};
				});
			}
		}
	};
</script>
